import React, { FC } from 'react'

const HalfCircle: FC = () => (
  <svg
    width="22"
    height="44"
    viewBox="0 0 22 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 2.098c0-.882-.717-1.604-1.597-1.539a21.5 21.5 0 0 0 0 42.882c.88.065 1.597-.657 1.597-1.54 0-.882-.717-1.59-1.596-1.668a18.303 18.303 0 0 1 0-36.467c.879-.077 1.596-.785 1.596-1.668Z"
      fill="#EC1C24"
    />
  </svg>
)

export default HalfCircle
